import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pa-4",
  style: {"height":"100vh","display":"flex","flex-direction":"column"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_my_card, { style: {"display":"flex","flex-direction":"column","flex":"1"} }, {
      header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "pa-4" }, [
          _createTextVNode(" 实时监测"),
          _createElementVNode("span", {
            class: "unit",
            style: {"font-size":".7em","opacity":".86"}
          }, "（千克/秒）")
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_my_card_body, { style: {"height":"100%","position":"relative"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              style: {"height":"100%","width":"100%"},
              ref: $setup.setRef
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}